import * as types from '../constants'
import { userLocalStorage } from 'config/local_storage'

const INITIAL_DATA_STATE = { alert: {}, currentTheme: 0, payment: undefined }

export default function reducer(state = INITIAL_DATA_STATE, actions) {
  switch (actions.type) {
    case types.SET_THEME:
      return { ...state, currentTheme: actions.payload }

    case types.SET_SHOW_ALERT:
      return Object.assign({}, state, { alert: actions.payload })

    case types.SET_TOKEN:
      return { ...state, token: actions.payload }

    case types.SET_PAYMENT_DATA:
      const paymentInfo = state.payment ? { ...state.payment, ...actions.payload } : actions.payload
      return { ...state, payment: paymentInfo }

    case types.SET_KEYCLOAK_USER_DATA:
      return { ...state, user: actions.payload }

    case types.SET_PROFILE:
      return { ...state, profile: actions.payload }

    case types.SIGN_OUT:
      userLocalStorage.clearAll()
      return INITIAL_DATA_STATE

    default:
      return state
  }
}
